import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';
import { Mediator } from '@spotahome/soyuz-mediator';

import { CHANNELS } from '../../utils/constants';

import Feature from '../Feature';
import { GRACE_PERIOD_CANCELLATION_FEATURE } from '../featureList';

import Button from '../../Button';

import GracePeriodCancellationIcon from './GracePeriodCancellationIcon';

const GracePeriodCancellationFeature = ({ collapsed, onCollapsedChange }) => {
  const handleOnClick = () => {
    SoyuzAnalytics.sendGA4Event('grace-period-cancellation-more', {});
    Mediator.publish(CHANNELS.OPEN_GRACE_PERIOD_CANCELLATION_MODAL);
  };

  return (
    <Feature
      featureName={GRACE_PERIOD_CANCELLATION_FEATURE}
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      renderBody={() => (
        <>
          <div>
            {trans(
              'property_show.book_now_card.grace.period.cancellation.body'
            )}
          </div>
          <Button color="link" onClick={handleOnClick}>
            {trans('home-ll.cta')}
          </Button>
        </>
      )}
      renderIcon={() => <GracePeriodCancellationIcon />}
      headerKey="property_show.book_now_card.grace.period.cancellation.title"
    />
  );
};

GracePeriodCancellationFeature.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onCollapsedChange: PropTypes.func.isRequired
};

export default GracePeriodCancellationFeature;
